var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from '@marketing/components/global/typography/Heading';
import Image from '../../Media/Image';
function TeamMember(_a) {
    var name = _a.name, biography = _a.biography, role = _a.role, imageData = _a.imageData;
    return (_jsxs("div", __assign({ className: "flex flex-col gap-sm-m md:gap-xs-m" }, { children: [_jsxs("div", __assign({ className: "flex md:flex-col justify-start items-center md:items-start gap-xs-m md:gap-xl-m" }, { children: [_jsx(Image, { imageData: imageData, className: "aspect-square h-[124px] shrink-0" }), _jsxs("div", { children: [_jsx(Heading, __assign({ size: "sm" }, { children: name })), _jsx("p", __assign({ className: "text-sm-med-m md:text-sm-md-d mt-xs-m" }, { children: role }))] })] })), _jsx("p", { children: biography })] })));
}
export default TeamMember;
